import { useMemo } from 'react';
import { FilterValueKey } from '../../panels/ProductCheckListFilterFields/types';
import { useProductCheckListFiltersContext } from '../../../contexts/ProductCheckListFiltersContext';
import { ProductData } from '../../../types';

export const useFilteredProductsData = (productsData: ProductData[]) => {
    const { filters } = useProductCheckListFiltersContext();

    const productIds = Object.values(filters[FilterValueKey.productIds]).flat();

    return useMemo(
        () =>
            productIds?.length
                ? productsData.filter(({ data }) => productIds.some((id) => id === data.id))
                : productsData,
        [productIds, productsData]
    );
};
